export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1759_.6c929e8e.jpg";